export const BadgeVariants = {
    LABEL_BG2: "label_bg2",
    LABEL_BEIGE: "label_beige",
    LABEL_DANGER: "label_danger",
    LABEL_DEFAULT: "label_default",
    LABEL_HIGHLIGHT: "label_highlight",
    LABEL_INFO: "label_info",
    LABEL_PRIMARY: "label_primary",
    LABEL_SECONDARY: "label_secondary",
    LABEL_SUBTLE_GREEN: "label_subtle_green",
    LABEL_SUCCESS: "label_success",
    LABEL_WARNING: "label_warning"
} as const;

type IBadgeVariantType = typeof BadgeVariants;

export type BadgeVariantsUnionType = IBadgeVariantType[keyof IBadgeVariantType];
export const BadgeVariants = {
    LABEL_BG2: "label_bg2",
    LABEL_BEIGE: "label_beige",
    LABEL_DANGER: "label_danger",
    LABEL_DEFAULT: "label_default",
    LABEL_HIGHLIGHT: "label_highlight",
    LABEL_INFO: "label_info",
    LABEL_PRIMARY: "label_primary",
    LABEL_SECONDARY: "label_secondary",
    LABEL_SUBTLE_GREEN: "label_subtle_green",
    LABEL_SUCCESS: "label_success",
    LABEL_WARNING: "label_warning"
} as const;

type IBadgeVariantType = typeof BadgeVariants;

export type BadgeVariantsUnionType = IBadgeVariantType[keyof IBadgeVariantType];
